import axios from 'axios'


const apiClient = axios.create({
  baseURL: 'https://my-json-server.typicode.com/18chai/event-list-mock-db',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export default {
  getEvents() {
    return apiClient.get('/events')
  },
  //Added new call
  getEvent(id) {
    return apiClient.get('/events/' + id)
  },
}
